export default {
    base: `https://buildspace-core.buildspace.app/projects`
}